import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const getExportDashboardSchema = (customer) => {
  return axios({
    url: '/config/' + customer + '/dashboard-schema',
    method: 'get'
  });
};

const useGetExportDashboardSchema = (customer) => {
  return useQuery(["get", "dashboardSchema", customer], () => getExportDashboardSchema(customer), {
    enabled: !!customer
  });
};

export default useGetExportDashboardSchema;